// Shared HTML sanitizer for server-supplied / scraped markup rendered via
// dangerouslySetInnerHTML.
//
// Why this exists: the TDS demand-summary blob is scraped VERBATIM from the
// TRACES portal, whose markup carries inline event handlers (e.g. the Net
// Payable anchors ship `onmouseover="getJustReptDialogBox()"`). Injected raw,
// hovering that link calls a TRACES-only function that does not exist in this
// app and throws an uncaught ReferenceError. Beyond that specific crash,
// unsanitized third-party HTML in dangerouslySetInnerHTML is a stored-XSS
// vector, so every such render site should pass through here.
//
// The config is the one EmbedGenerateResponse.jsx established: permissive on
// tags/attrs (tables, lists, headings, anchors survive - the demand-summary
// tables render intact) but scripts, event handlers and javascript: URLs are
// stripped. The FORBID lists are belt-and-braces; DOMPurify's defaults
// already remove script tags and all on* attributes.
import DOMPurify from "dompurify";

export function sanitizeHtml(html) {
  if (!html) return "";
  return DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    FORBID_TAGS: ["script", "iframe", "object", "embed"],
    FORBID_ATTR: ["onerror", "onload", "onclick", "onmouseover"],
  });
}
